import { useEffect, useRef } from 'react';

/**
 * Runs `onMount` once when `isOpen` transitions to true (modal content mounted).
 * Use inside modal body components that only render while open — avoids
 * `useEffect(() => { if (isOpen) ... }, [isOpen])` anti-patterns.
 */
export function useModalOpenMount(onMount: () => void, deps: readonly unknown[] = []) {
  const onMountRef = useRef(onMount);
  onMountRef.current = onMount;

  useEffect(() => {
    onMountRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller supplies open-scoped deps
  }, deps);
}
